import { LogOut } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const LeaveIcon = DeckardIconWrapper({ Icon: LogOut });
